import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { categories } from '@/mocks/categories';
import { siteInfo } from '@/mocks/site';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    if (!isHome) {
      setIsScrolled(true);
    } else {
      setIsScrolled(window.scrollY > 60);
    }
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isHome]);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6" aria-label="主导航">
        <div className="max-w-7xl mx-auto flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className={`font-heading text-xl font-semibold tracking-wide transition-colors duration-300 ${isScrolled ? 'text-foreground-950' : 'text-white'}`}>
              {siteInfo.name}
            </span>
            <span className={`hidden sm:inline-block text-xs px-2 py-0.5 rounded-full border transition-colors duration-300 ${isScrolled ? 'border-primary-300 text-primary-700 bg-primary-50' : 'border-white/40 text-white/90'}`}>
              {siteInfo.tagline}
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                isScrolled
                  ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50'
                  : 'text-white/90 hover:text-white hover:bg-white/10'
              } ${location.pathname === '/' ? (isScrolled ? 'text-primary-600 bg-primary-50' : 'text-white bg-white/10') : ''}`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                  isScrolled
                    ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50'
                    : 'text-white/90 hover:text-white hover:bg-white/10'
                } ${location.pathname.startsWith(`/category/${cat.slug}`) ? (isScrolled ? 'text-primary-600 bg-primary-50' : 'text-white bg-white/10') : ''}`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/articles"
              className={`px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                isScrolled
                  ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50'
                  : 'text-white/90 hover:text-white hover:bg-white/10'
              } ${location.pathname.startsWith('/articles') || location.pathname.startsWith('/article') ? (isScrolled ? 'text-primary-600 bg-primary-50' : 'text-white bg-white/10') : ''}`}
            >
              精选文章
            </Link>
            <Link
              to="/about"
              className={`px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                isScrolled
                  ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50'
                  : 'text-white/90 hover:text-white hover:bg-white/10'
              } ${location.pathname === '/about' ? (isScrolled ? 'text-primary-600 bg-primary-50' : 'text-white bg-white/10') : ''}`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md transition-colors ${
              isScrolled ? 'text-foreground-700 hover:bg-background-100' : 'text-white hover:bg-white/10'
            }`}
            aria-label={isMobileMenuOpen ? '关闭菜单' : '打开菜单'}
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200/70">
            <div className="max-w-7xl mx-auto px-4 py-3 flex flex-col gap-1">
              <Link to="/" className="px-4 py-3 rounded-md text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-primary-50 transition-colors">
                首页
              </Link>
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="px-4 py-3 rounded-md text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-primary-50 transition-colors"
                >
                  {cat.name}
                </Link>
              ))}
              <Link to="/articles" className="px-4 py-3 rounded-md text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-primary-50 transition-colors">
                精选文章
              </Link>
              <Link to="/about" className="px-4 py-3 rounded-md text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-primary-50 transition-colors">
                关于我们
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}